import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { RootState } from '../store/store';

interface PrivateRouteWithRoleProps {
  element: React.ReactElement;
  roles: string[];
}

const PrivateRouteWithRole: React.FC<PrivateRouteWithRoleProps> = ({ element, roles }) => {
  const profile = useSelector((state: RootState) => state.auth.profile);
  const location = useLocation();

  const userRole = profile?.role.toLowerCase();
  const requiredRoles = roles.map((role) => role.toLowerCase());

  if (!profile || (userRole && !requiredRoles.includes(userRole))) {
    return <Navigate replace state={{ from: location }} to="/" />;
  }

  return element;
};

export default PrivateRouteWithRole;
